import initialState from '../store/initialstate'
import C from  '../constants/search';

export default (state = initialState().Search, action = null) => {
    switch(action.type){
        case C.SET_SEARCH_KEYWORD:
            return state.set(C.SEARCH_KEYWORD, action.payload);

        case C.GET_SEARCH_DATA:
            return state.set(C.SEARCH_DATA, action.payload);

        case C.CHANGE_FILTER:
            return state.set(C.CURRENT_FILTER, action.payload);

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./reducers/search.js